export enum CelebrationType {
	Anniversary = 'work_anniversary',
	Birthday = 'birthday',
	Welcome = 'welcome',
}

export type Celebration = {
	created_at: string; // when the current year celebration was created
	date?: string; // date of the original celebration - date with actual year of the work anniversary
	display_name: string;
	id: string;
	profile_pic_url?: string;
	type: CelebrationType;
	user_id: string;
	username: string;
};

export type UpcomingCelebration = {
	date: string; // format is "YYYY-MM-DD"
	display_name: string;
	profile_pic_url?: string;
	type: CelebrationType;
	user_id: string;
	username: string;
};

export type CelebrationResult = {
	recent: Celebration[];
	today: Celebration[];
	upcoming: UpcomingCelebration[];
};

export type CelebrationResponse = {
	result: CelebrationResult;
	success: boolean;
};

export type MonthlyCelebration = {
	created_at?: string; // when the current year celebration was created
	date?: string; // date of the original celebration - date with actual year of the work anniversary
	display_name: string;
	id?: string; // does not exist if celebration is in the future
	interacted?: boolean;
	profile_pic_url?: string;
	type: CelebrationType;
	user_id: string;
};

export type MonthlyCelebrationResult = {
	all: {
		recent: MonthlyCelebration[];
		upcoming: MonthlyCelebration[];
	};
	relevant: {
		recent: MonthlyCelebration[];
		upcoming: MonthlyCelebration[];
	};
};

export type MonthlyCelebrationsResponse = {
	result: MonthlyCelebrationResult;
	success: boolean;
};

export type CelebrationGroup = {
	count: number;
	recent: MonthlyCelebration[];
	upcoming: MonthlyCelebration[];
};

export type MonthlyCelebrationsData = {
	all: CelebrationGroup;
	relevant: CelebrationGroup;
};
